export function storeMuteToSessionStorage(isMute: boolean) {
  sessionStorage.setItem('video-player-mute', JSON.stringify(isMute));
}

export function getMuteFromSessionStorage() {
  const isMute = sessionStorage.getItem('video-player-mute');
  return isMute ? JSON.parse(isMute) : undefined;
}

export function storeVolumeToSessionStorage(volume: number) {
  sessionStorage.setItem('video-player-volume', JSON.stringify(volume));
}

export function getVolumeFromSessionStorage() {
  const volume = sessionStorage.getItem('video-player-volume');
  return volume ? JSON.parse(volume) : undefined;
}
